//网站配置
import { apiAxios } from "@/api/axios";
import base from '../config'
let baseURL = base.baseURL
export default {

  //option-模板类型列表
  optionTypeList: (data) => apiAxios('post', baseURL + '/config.option.typeList', data),
  //option-列表
  optionList: (data) => apiAxios('post', baseURL + '/config.option.list', data),
  //option-新增
  optionStore: (data) => apiAxios('post', baseURL + '/config.option.store', data),
  //option-修改排序
  optionUpdateSort: (data) => apiAxios('post', baseURL + '/config.option.updateSort', data),
  //option-修改
  optionUpdate: (data) => apiAxios('post', baseURL + '/config.option.update', data),
  //option-删除
  optionDelete: (data) => apiAxios('post', baseURL + '/config.option.delete', data),

  //物流-列表
  logisticsList: (data) => apiAxios('post', baseURL + '/config.logistics.list', data),
  //物流-新增物流
  logisticsStore: (data) => apiAxios('post', baseURL + '/config.logistics.store', data),
  //物流-删除物流
  logisticsDelete: (data) => apiAxios('post', baseURL + '/config.logistics.delete', data),
  //物流-修改排序
  logisticsUpdateSort: (data) => apiAxios('post', baseURL + '/config.logistics.updateSort', data),
  //物流-修改logo
  logisticsUpdateLogo: (data) => apiAxios('post', baseURL + '/config.logistics.updateLogo', data),
  //物流-详情
  logisticsDetail: (data) => apiAxios('post', baseURL + '/config.logistics.detail', data),
  //物流-正常发开关
  logisticsIs_show: (data) => apiAxios('post', baseURL + '/config.logistics.is_show', data),
  //物流-修改提示语
  logisticsUpdateTips: (data) => apiAxios('post', baseURL + '/config.logistics.updateTips', data),
  //物流--单号自动生成开关
  logisticsSetIsAutoNo: (data) => apiAxios('post', baseURL + '/config.logistics.isAutoNo', data),
  //物流-单号自动生成规则设置
  logisticsSetAutoNoRule: (data) => apiAxios('post', baseURL + '/config.logistics.setAutoNoRule', data),
  //计算规则-新增
  logisticsAddRuleConfig: (data) => apiAxios('post', baseURL + '/config.logistics.addRuleConfig', data),
  //计算规则-修改
  logisticsUpdateRuleConfig: (data) => apiAxios('post', baseURL + '/config.logistics.updateRuleConfig', data),
  //计算规则-开关
  logisticsUpdateStatus: (data) => apiAxios('post', baseURL + '/config.logistics.updateStatus', data),
  //计算规则-修改中文说明
  logisticsUpdateNoteCn: (data) => apiAxios('post', baseURL + '/config.logistics.updateNoteCn', data),
  //计算规则-修改日文说明
  logisticsUpdateNoteJp: (data) => apiAxios('post', baseURL + '/config.logistics.updateNoteJp', data),
  //物流-获取新单号
  getNewNumber: (data) => apiAxios('post', baseURL + '/config.logistics.getNewNumber', data),






  //网站菜单导航列表
  webMainMenuList: (data) => apiAxios('post', baseURL + '/config.webMainMenuList', data),
  //网站菜单导航新增&&编辑
  webMainMenuSave: (data) => apiAxios('post', baseURL + '/config.webMainMenuSave', data),
  //网站菜单导航删除
  webMainMenuDelete: (data) => apiAxios('post', baseURL + '/config.webMainMenuDelete', data),
  //同步菜单列表到客户端
  synchronizationMainMenu: (data) => apiAxios('post', baseURL + '/config.synchronizationMainMenu', data),
  //获取供货商平台类目
  getShopGoodsGroup: (data) => apiAxios('post', baseURL + '/config.getShopGoodsGroup', data),


  //网站Banner列表
  bannerList: (data) => apiAxios('post', baseURL + '/config.client.bannerList', data),
  //保存Banner
  bannerSave: (data) => apiAxios('post', baseURL + '/config.client.bannerSave', data),
  //一键设置Banner播放时间
  bannerPlayTimeSet: (data) => apiAxios('post', baseURL + '/config.client.bannerPlayTimeSet', data),
  // 首页静态横幅配置
  staticBannerGet: (data) => apiAxios('post', baseURL + '/config.staticBanner.get', data),
  staticBannerSave: (data) => apiAxios('post', baseURL + '/config.staticBanner.save', data),

  //商品主分类
  mainGoodsGroup: (data) => apiAxios('post', baseURL + '/config.client.mainGoodsGroup', data),
  //新增&&编辑商品主分类
  mainGoodsGroupSave: (data) => apiAxios('post', baseURL + '/config.client.mainGoodsGroupSave', data),
  //删除商品主分类
  mainGoodsGroupDelete: (data) => apiAxios('post', baseURL + '/config.client.mainGoodsGroupDelete', data),

  //默认个性化商品分类
  hotGoodsGroup: (data) => apiAxios('post', baseURL + '/config.client.hotGoodsGroup', data),
  //删除默认个性化商品分类
  hotGoodsGroupDelete: (data) => apiAxios('post', baseURL + '/config.client.hotGoodsGroupDelete', data),
  //新增&&编辑默认个性化商品分类
  hotGoodsGroupSave: (data) => apiAxios('post', baseURL + '/config.client.hotGoodsGroupSave', data),
  //关键词检索阿里分类
  getCategoryByKeyword: (data) => apiAxios('post', baseURL + '/config.client.getCategoryByKeyword', data),


  //默认常规商品分类
  autoGoodsGroup: (data) => apiAxios('post', baseURL + '/config.client.autoGoodsGroup', data),
  //删除默认常规商品分类
  autoGoodsGroupDelete: (data) => apiAxios('post', baseURL + '/config.client.autoGoodsGroupDelete', data),
  //新增&&编辑默认常规商品分类
  autoGoodsGroupSave: (data) => apiAxios('post', baseURL + '/config.client.autoGoodsGroupSave', data),



  //运营-品名模板列表
  materialList: (data) => apiAxios('post', baseURL + '/config.material.materialTplList', data),
  //运营-品名-获取单个sku的所有业务员录入的信息
  materialGetAdminInput: (data) => apiAxios('post', baseURL + '/config.material.getAdminInput', data),
  //运营-品名-批量设置标准信息提交
  materialSetStandard: (data) => apiAxios('post', baseURL + '/config.material.setStandard', data),


  //获取个性化推荐商品
  hotGoodsGet: (data) => apiAxios('post', baseURL + '/config.client.hotGoodsGet', data),
  //编辑个性化推荐商品
  hotGoodsSave: (data) => apiAxios('post', baseURL + '/config.client.hotGoodsSave', data),
  //删除个性化推荐商品
  hotGoodsDelete: (data) => apiAxios('post', baseURL + '/config.client.hotGoodsDelete', data),
  //同步个性化推荐商品至客户端
  hotGoodsToClient: (data) => apiAxios('post', baseURL + '/config.client.hotGoodsToClient', data),



  //编辑常规推荐商品
  autoGoodsSave: (data) => apiAxios('post', baseURL + '/config.client.autoGoodsSave', data),
  //获取常规推荐商品
  autoGoodsGet: (data) => apiAxios('post', baseURL + '/config.client.autoGoodsGet', data),
  //删除常规推荐商品
  autoGoodsDelete: (data) => apiAxios('post', baseURL + '/config.client.autoGoodsDelete', data),
  //同步常规推荐商品至客户端
  autoGoodsToClient: (data) => apiAxios('post', baseURL + '/config.client.autoGoodsToClient', data),

  //管理端-列表
  noticeList: (data) => apiAxios('post', baseURL + '/config.notice.list', data),
  //管理端-人员查询
  getAccountInfo: (data) => apiAxios('post', baseURL + '/config.notice.getAccountInfo', data),
  //管理端-添加通知
  noticeStore: (data) => apiAxios('post', baseURL + '/config.notice.store', data),
  // 管理端-获取单个通知的部分用户列表
  getNoticePartClientAndAdmin: (data) => apiAxios('post', baseURL + '/config.notice.getNoticePartClientAndAdmin', data),
  // 后台用户-获取未查看的通知
  unreadNotice: (data) => apiAxios('post', baseURL + '/config.notice.unreadNotice', data),
  // 后台用户-标记已读
  readNotice: (data) => apiAxios('post', baseURL + '/config.notice.readNotice', data),
  // 后台用户-查看通知列表
  adminNoticeList: (data) => apiAxios('post', baseURL + '/config.notice.adminNoticeList', data),
  //后台用户-批量删除通知
  batchDelete: (data) => apiAxios('post', baseURL + '/config.notice.batchDelete', data),




  //搜索关键词数据列表
  searchKeywords: (data) => apiAxios('post', baseURL + '/config.translate.searchKeywords', data),
  //搜索关键词翻译结果确认
  searchKeywordsConfirm: (data) => apiAxios('post', baseURL + '/config.translate.searchKeywordsConfirm', data),
  //搜索关键词翻译结果修改
  searchKeywordsUpdate: (data) => apiAxios('post', baseURL + '/config.translate.searchKeywordsUpdate', data),


  //商品规格属性翻译结果确认
  goodsDetailConfirm: (data) => apiAxios('post', baseURL + '/config.translate.goodsDetailConfirm', data),
  //商品规格属性翻译结果修改
  goodsDetailUpdate: (data) => apiAxios('post', baseURL + '/config.translate.goodsDetailUpdate', data),
  //商品规格属性数据列表
  goodsDetail: (data) => apiAxios('post', baseURL + '/config.translate.goodsDetail', data),

  //物流列表
  internationalLogisticsList: (data) => apiAxios('post', baseURL + '/config.logistics.list', data),
  //新增物流
  addLogistics: (data) => apiAxios('post', baseURL + '/config.logistics.storeLogistics', data),
  //正常发
  normalHair: (data) => apiAxios('post', baseURL + '/config.logistics.toShow', data),
  //停发
  stopHair: (data) => apiAxios('post', baseURL + '/config.logistics.toHide', data),
  //删除物流
  deleteLogistics: (data) => apiAxios('post', baseURL + '/config.logistics.toDelete', data),
  //修改排序
  updateSort: (data) => apiAxios('post', baseURL + '/config.logistics.updateSort', data),
  //是否需要订柜
  updateLogisticsContainer: (data) => apiAxios('post', baseURL + '/config.logistics.isContainer', data),
  //物流规则-新增规则
  addLogisticsRule: (data) => apiAxios('post', baseURL + '/config.logistics.storeRule', data),
  //物流规则-启用停用规则
  changeRuleStatus: (data) => apiAxios('post', baseURL + '/config.logistics.changeRuleStatus', data),
  //物流规则-修改结束时间
  updateLogisticsRule: (data) => apiAxios('post', baseURL + '/config.logistics.updateEndAt', data),
  //修改logo
  updateLogisticsLogo: (data) => apiAxios('post', baseURL + '/config.logistics.updateLogo', data),
  //物流-仅vip可用开关
  is_vip: (data) => apiAxios('post', baseURL + '/config.logistics.is_vip', data),
  //简易比较表配置
  simpleCompare: (data) => apiAxios('post', baseURL + '/config.logistics.simpleCompare', data),
  //简易比较表配置查询
  simpleCompareGet: (data) => apiAxios('post', baseURL + '/config.logistics.simpleCompareGet', data),




  //违禁品-列表
  forbidGoodsList: (data) => apiAxios('post', baseURL + '/config.forbidGoods.list', data),
  //违禁品-类型枚举
  forbidTypes: (data) => apiAxios('post', baseURL + '/config.forbidGoods.forbidTypes', data),
  //违禁品-添加
  forbidGoodsStore: (data) => apiAxios('post', baseURL + '/config.forbidGoods.store', data),
  //违禁品-中国审核
  chinaConfirm: (data) => apiAxios('post', baseURL + '/config.forbidGoods.chinaConfirm', data),
  //违禁品-日本审核
  japanConfirm: (data) => apiAxios('post', baseURL + '/config.forbidGoods.japanConfirm', data),
  //违禁品-删除
  forbidGoodsDelete: (data) => apiAxios('post', baseURL + '/config.forbidGoods.delete', data),
  //违禁品-修改
  forbidGoodsUpdate: (data) => apiAxios('post', baseURL + '/config.forbidGoods.update', data),
  //违禁品-校验是否是后台提醒商品
  isAdminNoticeGoods: (data) => apiAxios('post', baseURL + '/config.forbidGoods.isAdminNoticeGoods', data),
  //违禁品-校验是否是客户端需要隐藏的商品
  isClientHideGoods: (data) => apiAxios('post', baseURL + '/config.forbidGoods.isClientHideGoods', data),
  //违禁品-修改运营备注
  updateOperateRemark: (data) => apiAxios('post', baseURL + '/config.forbidGoods.updateOperateRemark', data),

  //意见反馈-列表
  feedbackList: (data) => apiAxios('post', baseURL + '/config.feedback.list', data),
  // 意见反馈-保存备注
  feedbackupdateConfirmRemark: (data) => apiAxios('post', baseURL + '/config.feedback.updateConfirmRemark', data),
  // 意见反馈-审核
  feedbackconfirm: (data) => apiAxios('post', baseURL + '/config.feedback.confirm', data),
  // 意见反馈-修改运营备注
  updateOperatorRemark: (data) => apiAxios('post', baseURL + '/config.feedback.updateOperatorRemark', data),
  // 意见反馈-列表(不需要客户登录的)
  listUnLogin: (data) => apiAxios('post', baseURL + '/config.feedback.listUnLogin', data),
  // 意见反馈-修改处理备注(未登录客户)
  updateConfirmRemarkUnLogin: (data) => apiAxios('post', baseURL + '/config.feedback.updateConfirmRemarkUnLogin', data),
  // 意见反馈-审核(未登录的)
  confirmUnLogin: (data) => apiAxios('post', baseURL + '/config.feedback.confirmUnLogin', data),
  // 意见反馈-修改运营备注(未登录的)
  updateOperatorRemarkUnLogin: (data) => apiAxios('post', baseURL + '/config.feedback.updateOperatorRemarkUnLogin', data),

  // 客户评价-列表
  evaluationlist: (data) => apiAxios('post', baseURL + '/config.evaluation.list', data),
  // 客户评价-处理备注
  evaluationupdateDealRemark: (data) => apiAxios('post', baseURL + '/config.evaluation.updateDealRemark', data),
  // 客户评价-确认
  evaluationconfirm: (data) => apiAxios('post', baseURL + '/config.evaluation.confirm', data),

  // 手续费配置-可选规则
  ruleTypes: (data) => apiAxios('post', baseURL + '/config.serviceRate.ruleTypes', data),
  // 手续费配置-列表
  serviceRateList: (data) => apiAxios('post', baseURL + '/config.serviceRate.list', data),
  // 手续费配置-设置比例
  setRule: (data) => apiAxios('post', baseURL + '/config.serviceRate.setRule', data),
  //手续费配置-查询指定商品的实时手续费费率
  getRate: (data) => apiAxios('post', baseURL + '/config.serviceRate.getRate', data),

  //第三方仓库地址分类
  addressThirdPartyGroup: (data) => apiAxios('post', baseURL + '/config.addressThirdParty.group', data),
  //第三方仓库地址列表
  addressThirdPartyList: (data) => apiAxios('post', baseURL + '/config.addressThirdParty.list', data),
  //第三方仓库地址保存
  addressThirdPartySave: (data) => apiAxios('post', baseURL + '/config.addressThirdParty.save', data),
  //第三方仓库地址删除
  addressThirdPartyDelete: (data) => apiAxios('post', baseURL + '/config.addressThirdParty.delete', data),

  //APP版本列表
  appVersionList: (data) => apiAxios('post', baseURL + '/config.appVersionList', data),
  //APP发版校验最新版本号是否可使用
  // addressThirdPartyList: (data) => apiAxios('post', baseURL + '/config.appVersionCheck', data),
  //APP版本保存(发布/编辑)
  appVersionSave: (data) => apiAxios('post', baseURL + '/config.appVersionSave', data),
  //APP版本删除
  appVersionDelete: (data) => apiAxios('post', baseURL + '/config.appVersionDelete', data),

  //获取有设置内容的日历
  getCalendar: (data) => apiAxios('post', baseURL + '/config.getCalendar', data),
  //日历设置
  setCalendar: (data) => apiAxios('post', baseURL + '/config.setCalendar', data),


  //QA
  //分类-列表
  categoryList: (data) => apiAxios('post', baseURL + '/config.qa.categoryList', data),
  //分类-添加
  categoryAdd: (data) => apiAxios('post', baseURL + '/config.qa.categoryAdd', data),
  //分类-修改
  categoryEdit: (data) => apiAxios('post', baseURL + '/config.qa.categoryEdit', data),
  //分类-删除
  categoryDelete: (data) => apiAxios('post', baseURL + '/config.qa.categoryDelete', data),
  //文章-列表
  articleList: (data) => apiAxios('post', baseURL + '/config.qa.articleList', data),
  //文章-添加
  articleAdd: (data) => apiAxios('post', baseURL + '/config.qa.articleAdd', data),
  //文章-修改
  articleEdit: (data) => apiAxios('post', baseURL + '/config.qa.articleEdit', data),
  //分类-列表
  articleDelete: (data) => apiAxios('post', baseURL + '/config.qa.articleDelete', data),

  /* 发版日志 */
  // 列表
  releaseList: (data) => apiAxios('post', baseURL + '/config.release.list', data),
  // 可选发布平台枚举
  platformList: (data) => apiAxios('post', baseURL + '/config.release.platformList', data),
  // 添加发版日志
  releaseStore: (data) => apiAxios('post', baseURL + '/config.release.store', data),
  // 修改发版日志
  releaseUpdate: (data) => apiAxios('post', baseURL + '/config.release.update', data),
  // 删除发版日志
  releaseDestroy: (data) => apiAxios('post', baseURL + '/config.release.destroy', data),


  /*客户聊天 */
  // 投诉类型-列表
  complaintType: (data) => apiAxios('post', baseURL + '/chatManage.complaintType', data),
  // 客户聊天工具列表
  clientList: (data) => apiAxios('post', baseURL + '/chatManage.clientListV2', data),
  //客户-RC聊天历史
  rakuchatMessageList: (data) => apiAxios('post', baseURL + '/chatManage.rakuchatMessageList', data),
  // 客户-CW聊天历史
  cwMessageList: (data) => apiAxios('post', baseURL + '/chatManage.cwMessageList', data),
  //客户-RC投诉列表
  rakuchatMessageListComplain: (data) => apiAxios('post', baseURL + '/chatManage.rakuchatMessageListComplainV2', data),
  //客户-RC投诉-设置备注
  RCComplainRemark: (data) => apiAxios('post', baseURL + '/chatManage.RCComplainRemark', data),
  //客户-RC投诉-确认
  RCComplainConfirm: (data) => apiAxios('post', baseURL + '/chatManage.RCComplainConfirm', data),
  //客户-RC投诉-取消
  RCComplainReject: (data) => apiAxios('post', baseURL + '/chatManage.RCComplainReject', data),
  //客户-RC聊天上下50条上下文
  getRCComplainMessageContext: (data) => apiAxios('post', baseURL + '/chatManage.getRCComplainMessageContext', data),

  //客户-CW投诉列表
  cwMessageListComplain: (data) => apiAxios('post', baseURL + '/chatManage.cwMessageListComplainV2', data),
  //客户-CW投诉-设置备注
  CWComplainRemark: (data) => apiAxios('post', baseURL + '/chatManage.CWComplainRemark', data),
  //客户-CW投诉-确认
  CWComplainConfirm: (data) => apiAxios('post', baseURL + '/chatManage.CWComplainConfirm', data),
  //客户-CW投诉-取消
  CWComplainReject: (data) => apiAxios('post', baseURL + '/chatManage.CWComplainReject', data),
  //客户-CW聊天上下50条上下文
  getCWComplainMessageContext: (data) => apiAxios('post', baseURL + '/chatManage.getCWComplainMessageContext', data),

  //客户-待内部处理-实时修改处理思路
  dealUpdateRemark: (data) => apiAxios('post', baseURL + '/chatManage.deal.updateRemark', data),
  //客户-待部长审核-实时修改部长留言
  dealUpdateDepartRemark: (data) => apiAxios('post', baseURL + '/chatManage.deal.updateDepartRemark', data),
  //客户-待部长审核-实时修改日本留言
  dealUpdateJapanRemark: (data) => apiAxios('post', baseURL + '/chatManage.deal.updateJapanRemark', data),
  //客户-待部长确认-实时修改待部长确认备注
  updateDepartReconfirmRemark: (data) => apiAxios('post', baseURL + '/chatManage.deal.updateDepartReconfirmRemark', data),
  //客户-待部长确认-实时修改待部长确认备注
  toDepartReConfirmed: (data) => apiAxios('post', baseURL + '/chatManage.deal.toDepartReConfirmed', data),

  //客户-待内部处理-非投诉
  dealToCancel: (data) => apiAxios('post', baseURL + '/chatManage.deal.toCancel', data),
  //客户-待内部处理-提交到下一步
  dealToWaitDepart: (data) => apiAxios('post', baseURL + '/chatManage.deal.toWaitDepart', data),
  //客户-待部长审核-提交到下一步
  dealToWaitJapan: (data) => apiAxios('post', baseURL + '/chatManage.deal.toWaitJapan', data),
  //客户-待日本确认-提交到下一步
  dealToConfirmed: (data) => apiAxios('post', baseURL + '/chatManage.deal.toConfirmed', data),
  //客户聊天工具列表V2-tab数量统计
  clientListV2TabNum: (data) => apiAxios('post', baseURL + '/chatManage.clientListV2TabNum', data),

  // 客户聊天工具列表V3
  clientListV3: (data) => apiAxios('post', baseURL + '/chatManage.clientListV3', data),
  // 客户聊天工具列表V3-tab数量统计
  clientListV3TabNum: (data) => apiAxios('post', baseURL + '/chatManage.clientListV3TabNum', data),
  // 客户聊天工具列表V4
  clientListV4: (data) => apiAxios('post', baseURL + '/chatManage.clientListV4', data),
  //客户聊天工具列表TAB统计V4
  clientListV4TabNum: (data) => apiAxios('post', baseURL + '/chatManage.clientListV4TabNum', data),
  //客户-待内部处理-提交到下一步V4
  toWaitJapanV4: (data) => apiAxios('post', baseURL + '/chatManage.deal.toWaitJapanV4', data),
  //客户-待日本确认-提交到下一步V4
  japanConfirmV4: (data) => apiAxios('post', baseURL + '/chatManage.deal.japanConfirmV4', data),
  //客户-待部长确认-确认无误V4
  departConfirmV4: (data) => apiAxios('post', baseURL + '/chatManage.deal.departConfirmV4', data),
  //客户-待部长确认-提出复核V4
  departConfirmReviewV4: (data) => apiAxios('post', baseURL + '/chatManage.deal.departConfirmReviewV4', data),
  //客户-最终复核-提交到下一步V4
  japanReviewV4: (data) => apiAxios('post', baseURL + '/chatManage.deal.japanReviewV4', data),
  //客户-待评分-提交到下一步V4
  addScoreV4: (data) => apiAxios('post', baseURL + '/chatManage.deal.addScoreV4', data),
  //客户-待日本审核-实时修改日本留言V4
  updateJapanRemarkV4: (data) => apiAxios('post', baseURL + '/chatManage.deal.updateJapanRemarkV4', data),
  //客户-待部长审核-实时修改部长留言V4
  updateDepartRemarkV4: (data) => apiAxios('post', baseURL + '/chatManage.deal.updateDepartRemarkV4', data),

  //关键词-列表
  getChatKeywords: (data) => apiAxios('post', baseURL + '/chatManage.getChatKeywords', data),
  //关键词-添加
  addChatKeywords: (data) => apiAxios('post', baseURL + '/chatManage.addChatKeywords', data),
  //关键词-删除
  deleteChatKeywords: (data) => apiAxios('post', baseURL + '/chatManage.deleteChatKeywords', data),
  //关键词-修改
  updateChatKeywords: (data) => apiAxios('post', baseURL + '/chatManage.updateChatKeywords', data),


  //榜单设置列表
  rankingList: (data) => apiAxios('post', baseURL + '/config.ranking.list', data),
  //榜单设置添加
  rankingStore: (data) => apiAxios('post', baseURL + '/config.ranking.store', data),
  //榜单设置修改
  rankingUpdate: (data) => apiAxios('post', baseURL + '/config.ranking.update', data),
  //榜单设置删除
  rankingDelete: (data) => apiAxios('post', baseURL + '/config.ranking.delete', data),

  //新手指南-文章-列表
  guideArticleList: (data) => apiAxios('post', baseURL + '/config.guide.articleList', data),
  //新手指南-分类-添加
  categoryStore: (data) => apiAxios('post', baseURL + '/config.guide.categoryStore', data),
  //新手指南-分类-修改
  categoryUpdate: (data) => apiAxios('post', baseURL + '/config.guide.categoryUpdate', data),
  //新手指南-分类-删除
  categoryDestroy: (data) => apiAxios('post', baseURL + '/config.guide.categoryDestroy', data),
  //新手指南-文章-添加
  articleStore: (data) => apiAxios('post', baseURL + '/config.guide.articleStore', data),
  //新手指南-文章-修改
  articleUpdate: (data) => apiAxios('post', baseURL + '/config.guide.articleUpdate', data),
  //新手指南-文章-删除
  articleDestroy: (data) => apiAxios('post', baseURL + '/config.guide.articleDestroy', data),
  //新手指南-设置是否展示NEW
  guideIsNew: (data) => apiAxios('post', baseURL + '/config.guide.isNew', data),
  //新手指南-文章-切换是否需要登录才能查看
  switchNeedLogin: (data) => apiAxios('post', baseURL + '/config.guide.switchNeedLogin', data),

  //新手指南-文章-列表H5
  guideArticleListH5: (data) => apiAxios('post', baseURL + '/config.guide.articleListH5', data),
  //新手指南-分类-添加H5
  categoryStoreH5: (data) => apiAxios('post', baseURL + '/config.guide.categoryStoreH5', data),
  //新手指南-分类-修改H5
  categoryUpdateH5: (data) => apiAxios('post', baseURL + '/config.guide.categoryUpdateH5', data),
  //新手指南-分类-删除H5
  categoryDestroyH5: (data) => apiAxios('post', baseURL + '/config.guide.categoryDestroyH5', data),
  //新手指南-文章-添加H5
  articleStoreH5: (data) => apiAxios('post', baseURL + '/config.guide.articleStoreH5', data),
  //新手指南-文章-修改H5
  articleUpdateH5: (data) => apiAxios('post', baseURL + '/config.guide.articleUpdateH5', data),
  //新手指南-文章-删除H5
  articleDestroyH5: (data) => apiAxios('post', baseURL + '/config.guide.articleDestroyH5', data),
  //新手指南-设置是否展示NEW
  guideIsNewH5: (data) => apiAxios('post', baseURL + '/config.guide.isNewH5', data),

  // 自营商品-列表
  rakuProductList: (data) => apiAxios('post', baseURL + '/admin/rakuProduct/list', data),
  // 自营商品-详情
  rakuProductDetail: (data) => apiAxios('post', baseURL + '/admin/rakuProduct/detail', data),
  // 自营商品-删除
  rakuProductDelete: (data) => apiAxios('post', baseURL + '/admin/rakuProduct/delete', data),
  // 自营商品-添加
  rakuProductStore: (data) => apiAxios('post', baseURL + '/admin/rakuProduct/store', data),
  // 自营商品-修改
  rakuProductUpdate: (data) => apiAxios('post', baseURL + '/admin/rakuProduct/update', data),
  // 自营商品-一键导入商品
  importProduct: (data) => apiAxios('post', baseURL + '/admin/rakuProduct/importProduct', data),
  // 自营商品-商品批量放入货盘
  batchAddPallet: (data) => apiAxios('post', baseURL + '/admin/rakuProduct/batchAddPallet', data),
  // 自营商品-修改状态
  statusSave: (data) => apiAxios('post', baseURL + '/admin/rakuProduct/statusSave', data),


  // 自营商品-分类列表
  classifyList: (data) => apiAxios('post', baseURL + '/admin/rakuProduct/classifyList', data),
  // 自营商品-分类添加
  classifyStore: (data) => apiAxios('post', baseURL + '/admin/rakuProduct/classifyStore', data),
  // 自营商品-分类修改
  classifyUpdate: (data) => apiAxios('post', baseURL + '/admin/rakuProduct/classifyUpdate', data),
  // 自营商品-分类删除
  classifyDelete: (data) => apiAxios('post', baseURL + '/admin/rakuProduct/classifyDelete', data),

  // 自营商品-货盘配置列表
  palletConfigList: (data) => apiAxios('post', baseURL + '/admin/rakuProduct/palletConfigList', data),
  // 自营商品-货盘配置保存
  palletConfigSave: (data) => apiAxios('post', baseURL + '/admin/rakuProduct/palletConfigSave', data),
  // 自营商品-货盘配置删除
  palletConfigDelete: (data) => apiAxios('post', baseURL + '/admin/rakuProduct/palletConfigDelete', data),


  // option说明-添加分类
  optionDescCategoryStore: (data) => apiAxios('post', baseURL + '/config.optionDesc.categoryStore', data),
  // option说明-修改分类
  optionDescCategoryUpdate: (data) => apiAxios('post', baseURL + '/config.optionDesc.categoryUpdate', data),
  // option说明-删除分类
  optionDescCategoryDelete: (data) => apiAxios('post', baseURL + '/config.optionDesc.categoryDelete', data),
  // option说明-添加option
  optionDescOptionStore: (data) => apiAxios('post', baseURL + '/config.optionDesc.optionStore', data),
  // option说明-修改option
  optionDescOptionUpdate: (data) => apiAxios('post', baseURL + '/config.optionDesc.optionUpdate', data),
  // option说明--删除option
  optionDescOptionDelete: (data) => apiAxios('post', baseURL + '/config.optionDesc.optionDelete', data),
  // option说明-列表
  optionDescList: (data) => apiAxios('post', baseURL + '/config.optionDesc.list', data),

  // 推荐商品列表
  recommendGoodsList: (data) => apiAxios('post', baseURL + '/config.recommendGoodsList', data),
  // 推荐商品修改
  recommendGoodsListUpdate: (data) => apiAxios('post', baseURL + '/config.recommendGoodsListUpdate', data),
  // 获取商品信息
  getGoodsInfo: (data) => apiAxios('post', baseURL + '/config.getGoodsInfo', data),
  // 同步普通荐数据到客户端
  synchronizationRecommendedGoods: (data) => apiAxios('post', baseURL + '/config.synchronizationRecommendedGoods', data),
  // 推荐商品移动
  recommendGoodsMove: (data) => apiAxios('post', baseURL + '/config.recommendGoodsMove', data),

  // 底价配置-列表
  goodsPriceConfigList: (data) => apiAxios('post', baseURL + '/config.goodsPriceConfig.list', data),
  // 底价配置-添加
  goodsPriceConfigStore: (data) => apiAxios('post', baseURL + '/config.goodsPriceConfig.store', data),
  // 底价配置-修改
  goodsPriceConfigUpdate: (data) => apiAxios('post', baseURL + '/config.goodsPriceConfig.update', data),
  // 底价配置-删除
  goodsPriceConfigDelete: (data) => apiAxios('post', baseURL + '/config.goodsPriceConfig.delete', data),

  //统一问题登记-状态枚举
  aftersaleIssueStatusEnum: (data) => apiAxios('post', baseURL + '/aftersale.issue.statusEnum', data),
  //统一问题登记-问题分类枚举
  aftersaleIssueProblemCategoryEnum: (data) => apiAxios('post', baseURL + '/aftersale.issue.problemCategoryEnum', data),
  //统一问题登记-状态统计
  aftersaleIssueStatusStatistics: (data) => apiAxios('post', baseURL + '/aftersale.issue.statusStatistics', data),
  //统一问题登记-列表
  aftersaleIssueList: (data) => apiAxios('post', baseURL + '/aftersale.issue.list', data),
  //统一问题登记-创建
  aftersaleIssueCreate: (data) => apiAxios('post', baseURL + '/aftersale.issue.create', data),
  //统一问题登记-取消
  aftersaleIssueCancel: (data) => apiAxios('post', baseURL + '/aftersale.issue.cancel', data),
  //统一问题登记-确认
  aftersaleIssueConfirm: (data) => apiAxios('post', baseURL + '/aftersale.issue.confirm', data),
  //统一问题登记-业务处理
  aftersaleIssueBizHandle: (data) => apiAxios('post', baseURL + '/aftersale.issue.bizHandle', data),
  //统一问题登记-领导决策
  aftersaleIssueLeaderDecision: (data) => apiAxios('post', baseURL + '/aftersale.issue.leaderDecision', data),
  //统一问题登记-最终处理
  aftersaleIssueFinalHandle: (data) => apiAxios('post', baseURL + '/aftersale.issue.finalHandle', data),
  //统一问题登记-详情
  aftersaleIssueDetail: (data) => apiAxios('post', baseURL + '/aftersale.issue.detail', data),
  //统一问题登记-业务处理方案编辑
  updateBizSolution: (data) => apiAxios('post', baseURL + '/aftersale.issue.updateBizSolution', data),
  //统一问题登记-课长决策方案编辑
  updateLeaderSolution: (data) => apiAxios('post', baseURL + '/aftersale.issue.updateLeaderSolution', data),
  //统一问题登记-最终处理方案编辑
  updateFinalSolution: (data) => apiAxios('post', baseURL + '/aftersale.issue.updateFinalSolution', data),
  //统一问题登记-确认处理结果
  aftersaleIssueUpdateConfirmResult: (data) => apiAxios('post', baseURL + '/aftersale.issue.updateConfirmResult', data),
}
